import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostListener, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MultipleUnsavedChangesDialogModel, SaveChangesResult } from './generic-dialogs.model';

@Component({
	template: `
		<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
			<h1 mat-dialog-title cdkDragHandle>{{ title }}</h1>
		</div>

		<div [innerHtml]="message" mat-dialog-content></div>

		<div mat-dialog-actions align="end">
			<button (click)="cancel()" mat-stroked-button>Cancel</button>
			<button (click)="discardAllChanges()" mat-stroked-button color="warn">{{ discardMessage }}</button>
		</div>
	`,
	standalone: true,
	imports: [CommonModule, DragDropModule, MatButtonModule, MatDialogModule],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultipleUnsavedChangesDialogComponent {
	title: string;
	message: SafeHtml;

	discardMessage = 'Discard all changes';

	constructor(
		public dialogRef: MatDialogRef<MultipleUnsavedChangesDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: MultipleUnsavedChangesDialogModel,
		private domSanitizer: DomSanitizer,
	) {
		this.title = 'Unsaved changes';

		// Function to wrap the name in a <strong> tag.
		const strongText = (text: string) => `<strong>${text}</strong>`;

		const isMultiple = data.typeNames.length > 1;

		// Build the tabs list, being 1st, 2nd and last, etc.
		const tabList = !isMultiple
			? `${strongText(data.typeNames[0])} tab.`
			: data.typeNames
					.slice(0, data.typeNames.length - 1)
					.map((name) => strongText(name))
					.join(', ') + ` and ${strongText(data.typeNames[data.typeNames.length - 1])} tabs.`;

		this.message = this.domSanitizer.bypassSecurityTrustHtml(
			`<p>There are unsaved changes on the ${tabList}<p>${
				isMultiple ? 'These' : 'This'
			} must be saved separately or ${isMultiple ? 'all' : ''} discarded.`,
		);

		if (!isMultiple) {
			this.discardMessage = 'Discard changes';
		}
	}

	@HostListener('document:keydown.d')
	discardAllChanges() {
		this.dialogRef.close(SaveChangesResult.Discard);
	}

	cancel() {
		this.dialogRef.close(SaveChangesResult.Cancel);
	}
}
